/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CourseChart from './CourseChart';
import { getTeachingAnalyticsData } from '../../../../../services/operations/courseApi';
import Loading from '../../../../../pages/Loading';
import IncomeChart from './IncomeChart';

const TeachingAnalytics = () => {
    const { user } = useSelector(state => state.profile);
    const [loading, setLoading] = useState(true);
    const [teachingAnalyticsData, setTeachingAnalyticsData] = useState([]);
    const dispatch = useDispatch();
    const { students, courses, earn, price } = teachingAnalyticsData.reduce(
        (acc, { studentCount, courseName, earn, price }) => {
            acc.students.push(studentCount);
            acc.courses.push(courseName);
            acc.earn.push(earn);
            acc.price.push(price);
            return acc;
        },
        { students: [], courses: [], earn: [], price: [] }
    );
    const totalStudent = teachingAnalyticsData.reduce((acc, { studentCount }) => acc + studentCount, 0);
    const totalEarning = teachingAnalyticsData.reduce((acc, { earn }) => acc + earn, 0);
    const backgroundColor = [];
    const borderColor = [];
    for (const index in teachingAnalyticsData) {
        backgroundColor.push(`rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.25)`);
        borderColor.push(backgroundColor[index].replace('0.2', '1'));
    }

    useEffect(() => {
        dispatch(getTeachingAnalyticsData(user._id, setTeachingAnalyticsData, setLoading));
    }, []);

    if (loading) {
        return <Loading />;
    }
    return (
        <div className='text-richblack-5 pb-10'>
            <header className='text-[27px] font-semibold mb-2'>
                Hi {user.firstName} 👋🏻
            </header>
            <p className='text-richblack-300 mb-4'>
                Education is the key, and you hold it.
            </p>
            <div className='flex md:flex-row flex-col-reverse items-center w-full gap-5'>
                <div className='bg-richblack-800 md:w-[70%] w-full p-4 text-center h-[25rem] rounded-lg'>
                    <CourseChart
                        students={students}
                        courses={courses}
                        backgroundColor={backgroundColor}
                        borderColor={borderColor}
                    />
                </div>
                <div className='bg-richblack-800 md:w-[30%] w-full h-[25rem] rounded-lg p-4 flex flex-col gap-3'>
                    <p className='font-bold text-lg'>
                        Statistics
                    </p>
                    <p className='font-bold text-lg text-richblack-300'>
                        Total Courses
                    </p>
                    <p className='text-2xl font-bold'>
                        {teachingAnalyticsData.length}
                    </p>
                    <p className='font-bold text-lg text-richblack-300'>
                        Total Students
                    </p>
                    <p className='text-2xl font-bold'>
                        {totalStudent}
                    </p>
                    <p className='font-bold text-lg text-richblack-300'>
                        Total Earning
                    </p>
                    <p className='text-2xl font-bold'>
                        ₹ {totalEarning.toLocaleString()}
                    </p>
                </div>
            </div>
            <div className='bg-richblack-800 my-10 p-4 text-center'>
                <IncomeChart
                    earn={earn}
                    courses={courses}
                    backgroundColor={backgroundColor}
                    borderColor={borderColor}
                    price={price}
                />
            </div>
        </div>
    );
}

export default TeachingAnalytics;